import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';

import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import { USER_DUPLICATE_SOURCE_MAP } from '@/modules/UserDuplicatesMerges/components/constants';

import User from '../list/user';
import UserRating from '../list/user-rating';
import UserResult from '../list/user-result';
import UserDuplicate from '../list/user-duplicate';
import BaseModel from '../list/base';
import UserPortfolio from '../list/user-portfolio';
import EventCertificate from '../list/event-certificate';

const API_PATH = 'user';

export const UsersManager = {
  objects: {}, // Сюда можно будет привязать какие-нибудь запросы /user/profile
  get profile() {
    const apiPath = 'user/profile';
    return {
      syncPfdo({ data } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.post(`/${apiPath}/sync-pfdo`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
    };
  },
  get public() {
    const apiPath = `public/${API_PATH}s`;
    const { index, show } = objectsRHandler(apiPath, User);
    return {
      index,
      show,
    };
  },
  get ratings() {
    const apiPath = 'ratings';
    const { index, show } = objectsRHandler(apiPath, UserRating);
    return {
      index,
      show,
      periods({ args, params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.get(`/${apiPath}/user/${id}/periods`, params),
          (response) => ({
            response,
            item: response.data.data,
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  get results() {
    const apiPath = 'results/users';
    const { index } = objectsRHandler(apiPath, UserResult);
    return {
      index,
      show({ args = [], params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.get(`${apiPath}/${id}`, params),
          (response) => ({
            response,
            items: response.data.data.map((i) => new UserResult(i, apiPath)),
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  get certificates() {
    const apiPath = 'event-certificates';
    return {
      index({ params } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.get(`/${apiPath}`, params),
          (response) => ({
            response,
            items: (response?.data?.data || []).map((item) => new EventCertificate(item)),
          }),
          (error) => ({ error }),
        );
      },
      file({ args = [], params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.get(`/${apiPath}/${id}/certificate`, params),
          (response) => ({
            response,
            item: response?.data?.data?.pdf || response?.data?.data?.file || null,
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  get duplicates() {
    const apiPath = 'user-duplicates';
    const { index, show } = objectsRHandler(apiPath, UserDuplicate);

    const checkFields = Object.values(USER_DUPLICATE_SOURCE_MAP).map(({ backendField }) => backendField);

    return {
      index,
      show,
      initiateDispatcher({ args = [], data, obs } = DEFAULT_PARAMS) {
        const [id] = args;
        const payload = {
          username: String(data.username || '').trim(),
          password: data.password,
        };
        return rHandler(
          apiService.post(`${apiPath}/${id}/initiate-dispatcher`, payload, { handleForbiddenLocally: true }),
          (response) => ({ response, item: new UserDuplicate(response.data.data) }),
          (error) => ({ error }),
          obs,
        );
      },
      cancel({ args = [], data } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.post(`${apiPath}/${id}/cancel`, data),
          (response) => ({
            response,
            item: new UserDuplicate(response?.data?.data),
          }),
          (error) => ({ error }),
        );
      },
      indexWithMerges: (params) => index(params).then(({ items = [], response, error }) => ({
        response,
        error,
        items: items.filter((item) => item.isPendingDispatcherMerge || checkFields.some((field) => item[field])),
      })),
      init({ params } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.post(`${apiPath}`, params),
          (response) => ({
            response,
            item: response.data.data,
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  get portfolio() {
    const apiPath = 'portfolio';
    return {
      ...objectsRHandler(apiPath, UserPortfolio),
    };
  },
};
